module.exports = __webpack_public_path__ + "static/media/gif1.99d29dd2.gif";